import React from "react";
import {
  lifecycle,
  compose,
  branch,
  renderNothing,
  renderComponent,
  withProps
} from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actions } from "../../modules/scooters";
import TryAgain from "../../components/TryAgain";
import Loading from "../../components/Loading";

const completion = () => {};

const failed = ({
  failFetchScooters,
  fetchingScooters,
  successFetchScooters,
  scooters
}) =>
  !fetchingScooters && failFetchScooters && !successFetchScooters && !scooters;
const isFetching = ({
  fetchingScooters,
  failFetchScooters,
  successFetchScooters,
  scooters
}) =>
  fetchingScooters && !failFetchScooters && !successFetchScooters && !scooters;
const isInitial = ({
  failFetchScooters,
  fetchingScooters,
  successFetchScooters,
  scooters
}) =>
  !failFetchScooters && !fetchingScooters && !successFetchScooters && !scooters;

const fetchScootersCallback = ({
  currentDealer,
  currentCustomer,
  fetchScooters,
  user,
  fetchCompletion
}) => () => {
  user &&
    fetchScooters({
      dealer_id: currentDealer.id,
      customer_id: currentCustomer.id
    }).then(fetchCompletion || completion);
};

const TryAgainScooter = ({ failFetchScooters, ...props }) => (
  <TryAgain
    label={failFetchScooters}
    onTryAgain={fetchScootersCallback(props)}
  />
);

const nonOptimalStates = states =>
  compose(...states.map(state => branch(state.when, state.render)));

const withLifeCycle = lifecycle({
  componentDidMount() {
    fetchScootersCallback(this.props)();
  },
  componentWillUnmount() {
    this.props.resetState(["currentScooter", "scooters"]);
  }
});

const mapStateToProps = state => ({
  ...(state.scooters || {}),
  currentDealer: state.dealers.currentDealer,
  currentCustomer: state.customers.currentCustomer,
  user: state.auth.user
});
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(actions, dispatch),
  dispatch
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withLifeCycle,
  nonOptimalStates([
    {
      when: isFetching,
      render: renderComponent(withProps({ label: "Loading Scooters" })(Loading))
    },
    { when: failed, render: renderComponent(TryAgainScooter) },
    { when: isInitial, render: renderNothing }
  ])
);
